import { z } from "zod";

export const postCrewSchema = z.object({
	orgId: z.string(),
});
